<!-- <div class="card-container">
  <mat-card class="shadow">
    <mat-card-title>Expenses</mat-card-title>
    <mat-card-content>$ 0.00</mat-card-content>
  </mat-card>
  <mat-card class="shadow">
    <mat-card-title>Earning</mat-card-title>
    <mat-card-content>$ {{ totalRecAmnt }}</mat-card-content>
  </mat-card>
  <mat-card class="shadow">
    <mat-card-title>New Clients</mat-card-title>
    <mat-card-content>{{ newClients }}</mat-card-content>
  </mat-card>
  <mat-card class="shadow">
    <mat-card-title>Active Clients</mat-card-title>
    <mat-card-content>{{ activeClients }}</mat-card-content>
  </mat-card>
</div> -->
<div class="dashboard-container">
  <div class="top-cards-section">
    <div class="card">
      <div class="card-header">
        <h3>Total Sales</h3>
      </div>
      <div class="card-content">
        <h2>$5,400</h2>
        <p>Last 24 hours</p>
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <h3>New Users</h3>
      </div>
      <div class="card-content">
        <h2>{{ newClients }}</h2>
        <p>Last 24 hours</p>
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <h3>Active Projects</h3>
      </div>
      <div class="card-content">
        <h2>{{ activeClients }}</h2>
        <p>Ongoing Projects</p>
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <h3>Appointments Completed</h3>
      </div>
      <div class="card-content">
        <h2>23</h2>
        <p>Last 7 days</p>
      </div>
    </div>
  </div>
  <div class="appointments-section">
    <div class="appointment-card today">
      <div class="card-header">
        <h3>Today's Scheduled Appointments</h3>
        <span class="count">5</span>
      </div>
      <div class="card-content">
        <ul>
          <li *ngFor="let apt of todayApt">
            <strong>{{ apt.clientName }}</strong> - {{ apt.appotTime }}
            <span class="status scheduled">Scheduled</span>
          </li>
          <li *ngIf="todayApt.length === 0" class="no-data">
            No scheduled appointments for today.
          </li>
        </ul>
      </div>
    </div>

    <div class="appointment-card upcoming">
      <div class="card-header">
        <h3>Upcoming Appointments</h3>
        <span class="count">8</span>
      </div>
      <div class="card-content">
        <ul>
          <li *ngFor="let apt of comingApt">
            <strong>{{ apt.clientName }}</strong> - Tomorrow,
            {{ apt.appotTime }}
            <span class="status upcoming">Upcoming</span>
          </li>
          <li *ngIf="comingApt.length === 0" class="no-data">
            No upcoming appointments.
          </li>
          <!-- More appointments -->
        </ul>
      </div>
    </div>

    <div class="appointment-card overdue">
      <div class="card-header">
        <h3>Overdue Appointments</h3>
        <span class="count">2</span>
      </div>
      <div class="card-content">
        <ul>
          <li>
            <strong>Tom Harris</strong> - Yesterday, 04:00 PM
            <span class="status overdue">Overdue</span>
          </li>
          <li *ngIf="todayApt.length === 0" class="no-data">
            No overdue appointments.
          </li>
        </ul>
      </div>
    </div>

    <div class="appointment-card completed">
      <div class="card-header">
        <h3>Completed Appointments</h3>
        <span class="count">12</span>
      </div>
      <div class="card-content">
        <ul>
          <li *ngFor="let apt of completedApt">
            <strong>{{ apt.clientName }}</strong> - Today, {{ apt.appotTime }}
            <span class="status completed">Completed</span>
          </li>
          <li *ngIf="completedApt.length === 0" class="no-data">
            No completed appointments.
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
